<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">Frozen Time Period of {{userName}}</h4>
        <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
    </div>
    <mat-dialog-content class="">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="mat-custom-table">
                            <div class="table-responsive" [ngClass]="!showData ? '' : 'no-data-available'">
                                <table class="w-100" mat-table [dataSource]="dataSource" aria-describedby="">

                                    <ng-container matColumnDef="FreezeStartDate">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Freeze Start Date & Time
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span [title]="element.freezeStartTime | date:dateFormat.dateRangeTime" class="WrapData">{{element.freezeStartTime | date:dateFormat.dateRangeTime}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="FreezeEndDate">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Freeze End Date & Time
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                           <span [title]="element.freezeEndTime | date:dateFormat.dateRangeTime" class="WrapData">{{element.freezeEndTime | date:dateFormat.dateRangeTime}}</span>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns"
                                        [ngClass]="{ Inactive: !row.isActive }">
                                    </tr>
                                </table>
                                <div *ngIf="showData"
                                    [ngClass]="dataSource.filteredData && dataSource.filteredData.length > 0 ? 'hidden' : 'visible'">
                                    <h5 class="text-center no-data-available py-4">No any record found!</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>